import { createApi } from '@reduxjs/toolkit/query/react'
import { CONSTANTS } from '../../constants'
import { baseQueryConfigured } from '../../plugins/rtk-query.config'
import { Taxonomy } from '../../types'

export const taxonomyApi = createApi({
  reducerPath: 'taxonomyApi',
  baseQuery: baseQueryConfigured,
  tagTypes: ['Taxonomy'],
  endpoints: (builder) => ({
    getTaxonomies: builder.query<Taxonomy[], null>({
      query: () => ({
        url: CONSTANTS.API.TAXONOMIES,
      }),
      providesTags: ['Taxonomy'],
    }),
  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetTaxonomiesQuery } = taxonomyApi
